import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'


const Welcome = () =>{
    return(
        <div className="welcome-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="welcome-content">
                            <h2>Welcome to our big day</h2>
                            <p>The beauty of marriage is not always seen from the very beginning but rather as love grows and develops over time.</p>
                            {/*<div className="btn"><Link to="/home">RSVP</Link></div>*/}
                            {/*<div className="btn"><Link to="/home">Location</Link></div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Welcome;